import { PaymentTypes } from '~/constants/financeConstants'
import type { InvoiceOrEstimate } from '~/types'

export interface PaymentDialogParams {
  includeServiceFee: boolean
  invoice: InvoiceOrEstimate
  paymentController: {
    addPayment: (params: any) => void
  }
  setIsBraintreePaymentOpen: (value: boolean) => void
  shouldShowBraintreeFlow: boolean
}

export const createPaymentDialogParams = ({
  invoice,
  includeServiceFee,
  shouldShowBraintreeFlow,
  setIsBraintreePaymentOpen,
}: Omit<PaymentDialogParams, 'paymentController'>) => {
  if (!invoice) return undefined

  const { id, dueToPayNoFee, clientId } = invoice

  return {
    addPaymentDialogProps: {
      clientId,
      ComponentProps: {
        invoiceAmount: dueToPayNoFee,
        assignedInvoiceId: id,
        invoiceIds: [id],
        paymentType: includeServiceFee
          ? PaymentTypes.CREDIT_CARD
          : PaymentTypes.OTHER,
      },
    },
    posTerminalMigrationAction: shouldShowBraintreeFlow
      ? () => {
          setIsBraintreePaymentOpen(true)
        }
      : undefined,
  }
}

export const openPaymentDialogAfterSaving = ({
  invoice,
  includeServiceFee,
  shouldShowBraintreeFlow,
  paymentController,
  setIsBraintreePaymentOpen,
}: PaymentDialogParams) => {
  const params = createPaymentDialogParams({
    invoice,
    includeServiceFee,
    shouldShowBraintreeFlow,
    setIsBraintreePaymentOpen,
  })

  if (params) {
    paymentController.addPayment(params)
  }
}
